import { render, staticRenderFns } from "./BasicInfoTables.vue?vue&type=template&id=ce15e4b8&scoped=true&"
import script from "./BasicInfoTables.vue?vue&type=script&lang=js&"
export * from "./BasicInfoTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce15e4b8",
  null
  
)

export default component.exports